import { QuestionType } from '../dto';

export const ListQuestionTypes = [
  { value: QuestionType.Boolean, label: 'Yes No' },
  { value: QuestionType.SingleChoice, label: 'Single Choice' },
  { value: QuestionType.MultipleChoice, label: 'Multiple Choice' },
];
